<script lang="ts">
    import YouTubePlayer from "$/components/card/CardContent/YouTubePlayer.svelte";
    import { createEventDispatcher, onMount } from "svelte";
    import CardContentWrapper from "$/components/card/CardContent/CardContentWrapper.svelte";
    export let card;
    export let isGridCard = false;
    export let isExpanded = false;

    let cardContentRef = null;
    const dispatch = createEventDispatcher();

    function attachImageLoadListeners() {
        const images = cardContentRef.querySelectorAll("img");
        if (!images.length) return;

        let imagesToLoad = images.length;
        let totalImagesHeight = 0;
        images.forEach((img) => {
            const onLoad = () => {
                img.removeEventListener("load", onLoad);
                totalImagesHeight += img.clientHeight;
                imagesToLoad--;
                if (imagesToLoad === 0) {
                    dispatch("imagesLoaded", {
                        totalImagesHeight: totalImagesHeight,
                    });
                }
            };
            img.addEventListener("load", onLoad);
        });
    }

    onMount(() => {
        attachImageLoadListeners();
    });
</script>

<CardContentWrapper bind:elementRef={cardContentRef}>
    <YouTubePlayer
        bind:isExpanded
        bind:ref={cardContentRef}
        {isGridCard}
        url={card.urlPath}
    >
        {@html card.content}
    </YouTubePlayer>
</CardContentWrapper>

<style>
    @import "../../../main.css";
</style>
